import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Bets from '@/components/Bets'
import Home from '@/components/Home'
import TicketRaffles from '@/components/Ticket-Raffles'
import Leaderboard from '@/components/Leaderboard'
import Bounties from '@/components/Bounties'
import Donate from '@/components/Donate'
import Gold from '@/components/Gold'
import Rooms from '@/components/Rooms'
import RoomBrowser from '@/components/Room-Browser'
import LootShop from '@/components/Loot-Shop'
import EquippedItems from '@/components/Equipped-Items'
import Legal from '@/components/Legal'
import RoomItemManagement from '@/components/Room-Item-Management'
import RoomItemEditor from '@/components/Room-Item-Editor'
import LootBoxEditor from '@/components/Loot-Box-Editor'
import LootBoxManagement from '@/components/Loot-Box-Management'
import AdminPushNotifications from '@/components/Admin-Push-Notifications'
import Rates from '@/components/Rates'
import Settings from '@/components/Settings'
import Support from '@/components/Support'
import CrapsTable from '@/components/craps/Craps-Table'
import CrapsOverlay from '@/components/craps/Craps-Overlay'
import CrapsVerify from '@/components/craps/Craps-Verify'
import CrapsHelp from '@/components/craps/Craps-Help'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/craps', name: 'Craps', component: CrapsTable },
    { path: '/craps/help', name: 'CrapsHelp', component: CrapsHelp },
    { path: '/craps/overlay', name: 'CrapsOverlay', component: CrapsOverlay, meta: { publicOverlay: true } },
    { path: '/craps/verify/:id?', name: 'CrapsVerify', component: CrapsVerify },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/leaderboard',
      name: 'Leaderboard',
      component: Leaderboard
    },
    {
      path: '/bets',
      name: 'Bets',
      component: Bets
    },
    {
      path: '/hello',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/ticket-raffles',
      name: 'TicketRaffles',
      component: TicketRaffles
    },
    {
      path: '/bounties',
      name: 'Bounties',
      component: Bounties
    },
    {
      path: '/donate/:user_id',
      name: 'Donate',
      props: true,
      component: Donate
    },
    {
      path: '/donate',
      name: 'DonateSelf',
      component: Donate
    },
    {
      path: '/gold/:user_id',
      name: 'Gold',
      props: true,
      component: Gold
    },
    {
      path: '/gold',
      name: 'GoldSelf',
      component: Gold
    },
    {
      path: '/rooms/:twitch_name',
      name: 'Rooms',
      props: true,
      component: Rooms
    },
    {
      path: '/rooms',
      name: 'RoomsSelf',
      component: Rooms
    },
    {
      path: '/room-browser',
      name: 'RoomBrowser',
      component: RoomBrowser
    },
    {
      path: '/loot-shop',
      name: 'LootShop',
      component: LootShop
    },
    {
      path: '/equipped-items',
      name: 'EquippedItems',
      component: EquippedItems
    },
    {
      path: '/room-item-management',
      name: 'RoomItemManagement',
      component: RoomItemManagement
    },
    {
      path: '/loot-box-management',
      name: 'LootBoxManagement',
      component: LootBoxManagement
    },
    {
      path: '/room-item-editor/:itemId',
      name: 'RoomItemEditor',
      props: true,
      component: RoomItemEditor
    },
    {
      path: '/room-item-editor',
      name: 'RoomItemEditorCreate',
      component: RoomItemEditor
    },
    {
      path: '/loot-box-editor/:itemId',
      name: 'LootBoxEditor',
      props: true,
      component: LootBoxEditor
    },
    {
      path: '/loot-box-editor',
      name: 'LootBoxEditorCreate',
      component: LootBoxEditor
    },
    {
      path: '/admin-push-notifications',
      name: 'AdminPushNotifications',
      component: AdminPushNotifications
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal
    },
    {
      path: '/rates',
      name: 'Rates',
      component: Rates
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      props: route => ({ message: route.query.message })
    },
    {
      path: '/support',
      name: 'Support',
      component: Support
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js